class Periods {
    periodsData;
    constructor(data) {
        this.periodsData = data.periods;
    }
}
export default Periods;
